import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { faAngleRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress, Modal } from "@mui/material";
import { CURRENCY, weekDays } from "src/lib/constans";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAvailability } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import PrimaryBtn from "./GlobalComponents/primaryBtn";

// Style object for the modal
const customeStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgb(255, 255, 255)",
  maxWidth: 600,
  width: "100%",
  paddingTop: "10px",
  paddingBottom: "10px",
  borderRadius: 8,
};
// Style for the close button container
const backBtnMaain: React.CSSProperties = {
  position: "absolute",
  top: -10,
  right: -10,
  backgroundColor: "red",
  borderRadius: 100,
  width: 20,
  height: 20,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
// Style for the close button text
const backBtn: React.CSSProperties = {
  color: "white",
};

interface IDoctorAvailability {
  onlineAvalibility: IAvailability;
  timings: IAvailability[];
  _id: string;
}
const BookAppointmentBtn: React.FC<{ doctorId: string }> = ({ doctorId }) => {
  const [selectedDoctor, setSelectedDoctor] = useState<{
    loader: boolean;
    availability: IDoctorAvailability | null;
    _id: string | null;
  }>({
    loader: false,
    availability: null,
    _id: null,
  });
  const fetchDoctorAvailability = async (_id: string) => {
    const { res, err } = await httpRequest<IDoctorAvailability[]>({
      path: `/appoiment/doctor/${_id}`,
    });
    if (res) {
      setSelectedDoctor((prev) => ({ ...prev, availability: res[0] || null }));
    } else {
      toast(err, { type: "error" });
    }
    setSelectedDoctor((prev) => ({ ...prev, loader: false }));
  };

  useEffect(() => {
    if (selectedDoctor?._id) {
      fetchDoctorAvailability(selectedDoctor?._id);
    }
  }, [selectedDoctor?._id]);
  return (
    <>
      <Modal
        open={selectedDoctor?._id ? true : false}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={customeStyle}>
          <button
            style={backBtnMaain}
            onClick={() =>
              setSelectedDoctor((prev) => ({
                ...prev,
                availability: null,
                _id: null,
              }))
            }
          >
            <FontAwesomeIcon
              className="font-size-16px"
              icon={faXmark}
              size="2x"
              style={backBtn}
            />
          </button>
          <div className="top_bar border-b border-[#707070]">
            <p className="font-Poppins-SemiBold font-size-20px theme-color-green text-center py-4">
              Appointment Details
            </p>
          </div>
          {selectedDoctor?.loader ? (
            <div className="text-center my-3">
              <CircularProgress size={20} style={{ color: "#004540" }} />
            </div>
          ) : selectedDoctor?.availability ? (
            <>
              {selectedDoctor?.availability?.onlineAvalibility?.fees && (
                <div className="appointment-details flex items-center justify-between px-6 py-6">
                  <div className="w-[85%]">
                    <h1 className="font-Poppins-SemiBold font-size-20px mb-1">
                      Online Video Consultation
                    </h1>
                    <h2 className="font-Poppins-Regular font-size-16px mb-1">
                      Online video call
                    </h2>
                    <p className="font-Poppins-Medium font-size-16px text-[#2A872E] flex-wrap flex items-center">
                      {Object.keys(
                        selectedDoctor?.availability?.onlineAvalibility
                      )
                        .filter((key) => weekDays.includes(key))
                        .map((v, i, arr) => (
                          <span key={v}>
                            <span className="capitalize">{v}</span>
                            <span className="mx-1">
                              {i < arr.length - 1 && "|"}
                            </span>
                          </span>
                        ))}
                    </p>
                  </div>
                  <div className="flex flex-col w-[15%] justify-around self-start h-full">
                    <span className="font-Poppins-Medium text-end font-size-20px">
                      {CURRENCY}{" "}
                      {selectedDoctor?.availability?.onlineAvalibility.fees}
                    </span>
                    <Link
                      to={`/book-appointment/${selectedDoctor?._id}/${selectedDoctor?.availability?.onlineAvalibility._id}/view`}
                      className="self-end mt-6 size-7 rounded-full bg-[#E5E5F0] flex items-center justify-center"
                    >
                      <FontAwesomeIcon
                        icon={faAngleRight}
                        style={{ color: "#000046" }}
                      />
                    </Link>
                  </div>
                </div>
              )}
              {selectedDoctor?.availability?.timings?.map(
                (item: IAvailability, index: number) => (
                  <div
                    key={index}
                    className="appointment-details flex items-center justify-between px-6 py-6"
                  >
                    <div className="w-[80%]">
                      <h1 className="font-Poppins-SemiBold font-size-20px mb-1">
                        {item.hospitalName}
                      </h1>
                      <h2 className="font-Poppins-Regular font-size-16px mb-1">
                        In-person Consultation
                      </h2>
                      <p className="font-Poppins-Medium font-size-16px text-[#2A872E] flex-wrap flex items-center">
                        {Object.keys(item)
                          .filter((key) => weekDays.includes(key))
                          .map((v, i, arr) => (
                            <span key={v}>
                              <span className="capitalize">{v}</span>
                              <span className="mx-1">
                                {i < arr.length - 1 && "|"}
                              </span>
                            </span>
                          ))}
                      </p>
                    </div>
                    <div className="flex w-[20%] flex-col justify-around self-start h-full">
                      <span className="font-Poppins-Medium text-end font-size-20px">
                        {CURRENCY} {item.fees}
                      </span>
                      <Link
                        to={`/book-appointment/${selectedDoctor?._id}/${item._id}/view`}
                        className="self-end mt-6 size-7 rounded-full bg-[#E5E5F0] flex items-center justify-center"
                      >
                        <FontAwesomeIcon
                          icon={faAngleRight}
                          style={{ color: "#000046" }}
                        />
                      </Link>
                    </div>
                  </div>
                )
              )}
            </>
          ) : (
            <p className="text-center font-Poppins-Medium font-size-22px py-2">
              This doctor has no availability set.
            </p>
          )}
        </div>
      </Modal>
      <PrimaryBtn
        type="button"
        ButtonText="Book Appointment"
        btnExtraStyle={{ borderRadius: "100px", background: "#00443F" }}
        onPress={() =>
          setSelectedDoctor((prev) => ({
            ...prev,
            loader: true,
            _id: doctorId,
          }))
        }
      />
    </>
  );
};

export default BookAppointmentBtn;
